<template>
    <b-modal id="dpad2Modal" 
        static
        size="lg"
        :title="$t('dpad.addDpad2')" 
        hide-footer 
        @hidden="clearForm();">
        <b-overlay :show="showOverlay" rounded="sm">
            <b-form v-on:submit.prevent="createDpad2">
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="4">
                        <label for="typeId">{{ $t('dpad.dForm.fType') }}</label>
                        <select required id="typeId" 
                            class="form-control" 
                            v-model.number="dForm.typeId">
                            <option value=0>
                                {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                            </option>
                            <option v-for="t in types" :value=t.typeId>
                                {{ $i18n.locale()=='kz' ? t.typeName :t.typeNameRu}} 
                            </option>
                        </select>
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="dName">{{ $t('dpad.dForm.dName') }}</label>
                        <input  id="dName" 
                            class="form-control" 
                            v-model="dForm.dName">
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="tenderNumber">{{ $t('dpad.dForm.tenderNumber') }}</label>
                        <input  id="tenderNumber" 
                            class="form-control" 
                            v-model="dForm.tenderNumber">
                    </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="4">
                        <label for="beginDate">{{ $t('dpad.dForm.beginDate') }}</label>
                        <input  id="beginDate" 
                            type="date"
                            class="form-control" 
                            v-model="dForm.beginDate">
                    </b-col>

                    <b-col sm="auto" lg="4">
                        <label for="endDate">{{ $t('dpad.dForm.endDate') }}</label>
                        <input  id="endDate" 
                            type="date"
                            class="form-control" 
                            v-model="dForm.endDate">
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="tenderPrice">{{ $t('dpad.dForm.tenderPrice') }}</label>
                        <input  id="tenderPrice" 
                            class="form-control" 
                            v-model.number="dForm.tenderPrice">
                    </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="6">
                        <label for="tenderType">{{ $t('dpad.dForm.tenderType') }}</label>
                        <select required id="tenderType" 
                            class="form-control" 
                            v-model.number="dForm.tenderType">
                            <option value=0>
                                {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                            </option>
                            <option value=1>
                                Открытый тендер/аукцион tender
                            </option>
                            <option value=2>
                                Запрос ценовых предложений
                            </option>
                        </select>
                    </b-col>
                    <b-col sm="auto" lg="6">
                        <label for="departments">{{ $t('dpad.dForm.departments') }}</label>
                        <multiselect 
                            v-model="dForm.departments" 
                            :options="departments"
                            :multiple="true"
                            track-by="depNameRu"
                            :custom-label="customLabel"
                            >
                        </multiselect>
                    </b-col>
                </b-form-row>
                

                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="12">
                        <label for="desc">{{ $t('dpad.dForm.desc') }}</label>
                        <textarea  required id="desc" 
                            class="form-control" 
                            v-model="dForm.description"></textarea>
                    </b-col>
                </b-form-row>
              
                <b-form-row>
                    <b-col lg="12">
                        <b-row class="pt-2">
                            <b-col lg="6">
                                <b-button size="sm" block variant="primary" @click="closeModal()" class="mr-2" >{{$t("hForm.back")}}</b-button>
                            </b-col>
                            <b-col lg="6">
                                <b-button size="sm" block variant="success" type="submit" >{{$t("dpad.dForm.addDpad2")}}</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-overlay>
       
    </b-modal>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader,getMultipartHeader} from "@/config/config";
    import vue from 'vue';
    import Multiselect from 'vue-multiselect'
    import  'vue-multiselect/dist/vue-multiselect.min.css';
    export default {
        name:"DpadForm2",
        props:["types","departments","sysChange"],
        components:{
            Multiselect
        },
        data(){
            return {
                dForm:{
                    dId:0,
                    typeId:0,
                    dpadType:2,

                    departments:"",
                    dName:"",
                    tenderNumber:"",
                    tenderType:0,
                    tenderPrice:0,
                    beginDate:"",
                    endDate:"",
                    description:"",
                    

                },
                showOverlay:false,
            }
        },
        methods:{
            customLabel (option) {
                return `${option.depName} - ${option.depNameRu}`
            },
            createDpad2(){
                console.info("dForm > ",this.dForm);   
                this.showOverlay=true;
                axios.post(apiDomain+"/dpad2/create",this.dForm,{headers:getHeader()})
                .then(res=>{
                    console.info("res > ",res);
                    this.showOverlay=false;
                    this.clearForm();
                    this.sysChange();
                    this.$bvModal.hide("dpad2Modal");
                    
                }).catch(err=>{
                    console.error("err > ",err);
                    this.showOverlay=false;
                });
            },
            closeModal(){
                this.clearForm();
                this.$bvModal.hide("dpad2Modal");
            },
           
            
            clearForm(){
                this.dForm={
                    dId:0,
                    typeId:0,
                    dpadType:2,
                    departments:"",
                    dName:"",
                    tenderNumber:"",
                    tenderType:0,
                    tenderPrice:0,
                    beginDate:"",
                    endDate:"",
                    description:"",
                }
                
            },
            
        },
        created(){
            
        }
    }
</script>
<style >
  .modal .modal-huge {
    max-width: 80%;
  }
</style>